import { atomWithReset } from "jotai/utils";

export const sideMenu = atomWithReset({
  showMenu: false,
});
